import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import styles from './SendMessageForm.module.scss';
import Button from 'component/atom/forms/button/Button';
import TextEditor from 'component/atom/forms/text-editor/TextEditor';
import DropdownButton from 'component/atom/forms/dropdown-button/DropdownButton';
import { usePost } from 'hooks/usePost';
import { workflow } from 'hooks/endpoints';
import { useUpdateNodeInternals } from '@xyflow/react';
import toast from 'react-hot-toast';
import Input from 'component/atom/forms/input/input/Input';

const SendMessageForm = ({ id }) => {
  const formik = useFormikContext();

  return (
    <form
      className={styles['message-form']}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <div className={styles['editor-container']}>
        <Input
          placeholder='Enter Whatsapp Number'
          label='Whatsapp Number'
          value={formik.values.number}
          name='number'
          onChange={(e) => formik.setFieldValue('number', e.target.value)}
          error={formik.errors.number}
          touched={formik.touched.number}
          onBlur={formik.handleBlur}
        />

        <TextEditor
          placeholder='Enter your custom message...'
          name='message'
          value={formik.values.message}
          onChange={(value) => formik.setFieldValue('message', value)}
          error={formik.errors.message}
          touched={formik.touched.message}
          rows='15'
          className={styles['editor']}
          isCustom
          isToolbarReduced
          textEditorClassName={styles['editor-class']}
        />
      </div>
    </form>
  );
};

export default SendMessageForm;
